import { COWORKING_OFFER_TYPE_TITLE } from './constants';
import { ECoworkingOfferType, IOffer } from '../../../types/offer';

export interface ICommercialCoworkingTitleParams {
  isOfficeSearch?: boolean;
}

export function getCommercialCoworkingTitle(
  offer: IOffer,
  defaultTitle: string,
  params: ICommercialCoworkingTitleParams = {},
): string {
  const { coworkingOfferType, workplaceCount } = offer;
  const { isOfficeSearch = false } = params;

  if (!coworkingOfferType) {
    return defaultTitle;
  }

  if (coworkingOfferType === ECoworkingOfferType.Office) {
    const baseTitle = isOfficeSearch ? COWORKING_OFFER_TYPE_TITLE.office : COWORKING_OFFER_TYPE_TITLE.flexOffice;

    if (!isOfficeSearch && workplaceCount && workplaceCount > 0) {
      return `${baseTitle} на ${workplaceCount} чел.`;
    }

    return baseTitle;
  }

  return COWORKING_OFFER_TYPE_TITLE[coworkingOfferType] || defaultTitle;
}
